import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function CheckoutCancel() {
  return (
    <div
      data-testid="checkout-cancel"
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, background: '#F9FAFB', fontFamily: 'Inter, sans-serif',
      }}
    >
      <div style={{ maxWidth: 460, textAlign: 'center' }}>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#F3F4F6', color: '#525966', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <XCircle size={34} />
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', color: '#0A0A0A', margin: 0 }}>
          Checkout cancelled.
        </h1>
        <p style={{ color: '#525966', marginTop: 10, fontSize: 15, lineHeight: 1.55 }}>
          No changes were made to your account. You can pick a plan again any time from Settings.
        </p>
        <Link
          to="/app/settings?billing=1"
          data-testid="cancel-cta"
          style={{
            display: 'inline-block', marginTop: 24, padding: '13px 24px', borderRadius: 10,
            background: '#0A0A0A', color: 'white', fontWeight: 700, textDecoration: 'none', fontSize: 15,
          }}
        >
          Back to Settings
        </Link>
      </div>
    </div>
  );
}
